import { render, staticRenderFns } from "./AttendGroupAddOrUpdate.vue?vue&type=template&id=328f3ed2&scoped=true&"
import script from "./AttendGroupAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AttendGroupAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f3ed2",
  null
  
)

export default component.exports